(function () {
  'use strict';

  var DUREE   = 400;
  var STAGGER = 60;
  var GLISSE  = 10;
  var EASE    = 'cubic-bezier(0.4, 0, 0.22, 1)';
  var DELAI_MAX = 480;

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.orleaFadeCartes = function (grille) {
    if (!grille) return;
    if (reduit) return;

    var cartes = grille.querySelectorAll('.main_collection_product');
    if (!cartes.length) return;

    for (var i = 0; i < cartes.length; i++) {
      var c = cartes[i];
      c.style.transition = 'none';
      c.style.opacity = '0';
      c.style.transform = 'translateY(' + GLISSE + 'px)';
    }

    void grille.offsetWidth;

    for (var j = 0; j < cartes.length; j++) {
      var carte = cartes[j];
      var delai = Math.min(j * STAGGER, DELAI_MAX);
      carte.style.transition =
        'opacity ' + DUREE + 'ms ' + EASE + ' ' + delai + 'ms, ' +
        'transform ' + DUREE + 'ms ' + EASE + ' ' + delai + 'ms';
      carte.style.opacity = '1';
      carte.style.transform = 'translateY(0)';
    }

    var total = DUREE + Math.min((cartes.length - 1) * STAGGER, DELAI_MAX) + 60;
    setTimeout(function () {
      for (var k = 0; k < cartes.length; k++) {
        cartes[k].style.transition = '';
        cartes[k].style.opacity = '';
        cartes[k].style.transform = '';
      }
    }, total);
  };
})();